import { DependencyMapViewNode as DependencyMapViewNodeBase } from './DependencyMapViewNode';
import { DependencyMapViewNodeChildren } from './DependencyMapViewNodeChildren';
import { DependencyMapViewNodeReferences } from './DependencyMapViewNodeReferences';

export const DependencyMap = {
  ViewNode: DependencyMapViewNodeBase,
  ViewNodeChildren: DependencyMapViewNodeChildren,
  ViewNodeReferences: DependencyMapViewNodeReferences,
};
